import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { MultiSetTreeBuilder } from '../../General/Tree/MultiSet/multi-set-tree-builder';
import { TreeService } from '../../General/Tree/tree.service';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';

import { TreeWords } from './tree-words';
import { TreeGenerator } from '../../General/Tree/tree-generator';
import { Graph } from '../../General/graph/lib/graph';

@Component({
  selector: 'app-t-all-words-mult',
  templateUrl: './t-all-words-mult.component.html',
  styleUrls: ['./t-all-words-mult.component.css']
})
export class TAllWordsMultComponent extends GeneralTeacherComponent implements OnInit {
  private tree: Graph = null;
  private canvas: HTMLCanvasElement = null;
  private generateTreeButton: HTMLButtonElement = null;
  private hideContentButton: HTMLButtonElement = null;
  private subTreeButton: HTMLButtonElement = null;
  private backButton: HTMLButtonElement = null;
  private solutionButton: HTMLButtonElement = null;



  private readonly canvasID: string = 'graph-canvas';
  private readonly generateTreeID: string = 'generateTree';
  private readonly hideContentID: string = 'hideContent';
  private readonly subTreeID: string = 'selectSubTreeNode';
  private readonly backID: string = 'backButton';
  private readonly solutionID: string = 'solutionButton';
  private showsSolution: boolean = true;

  private readonly treeService: TreeService;

  private readonly maxWordLength: number = 6;

  private readFromConfig = false;

  alphabetCount: number = 0;

  alphabet1: string = "";
  alphabet2: string = "";
  alphabet3: string = "";
  alphabet4: string = "";
  alphabet5: string = "";
  alphabet6: string = "";

  wordLength1: number = 0;
  wordLength2: number = 0;
  wordLength3: number = 0;
  wordLength4: number = 0;
  wordLength5: number = 0;
  wordLength6: number = 0;


  hasCharRepetition: string = "false";



  constructor(protected topicsService: TopicService,
    protected activatedRoute: ActivatedRoute,
    treeService: TreeService) {
    super(topicsService, activatedRoute);
    this.type = 'allWordsMult';
    this.title = this.get('allWords');
    this.treeService = treeService;
    this.description = this.get('descriptionAllWordsMult');

  }

  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.hideContentButton = <HTMLButtonElement>document.getElementById(this.hideContentID);
    this.subTreeButton = <HTMLButtonElement>document.getElementById(this.subTreeID);
    this.backButton = <HTMLButtonElement>document.getElementById(this.backID);
    this.solutionButton = <HTMLButtonElement>document.getElementById(this.solutionID);
    this.solutionButton.innerText = this.get("showSolution");
    //If we load from configfile we dont need to create a new empty graph
    if (!this.readFromConfig) {
      this.generateTreeButton.addEventListener('click', this.generateTree, false);
      this.hideContentButton.addEventListener('click', this.hideContent, false)
      this.subTreeButton.addEventListener('click', this.onSelectSubTree, false);
      this.backButton.addEventListener('click', this.backToGraph, false);
      this.solutionButton.addEventListener('click', this.showSolution, false);
    }
  }

  generate() {
    let randomTree: [[any[], number][], string, boolean] = TreeGenerator.generateMultiWordTree();
    let alphabets: [any[], number][] = randomTree[0];
    let description: string = randomTree[1];
    let hasRepetition: boolean = randomTree[2];

    this.description = description;

    this.alphabetCount = alphabets.length;
    if (hasRepetition) {
      this.hasCharRepetition = 'true';
    }
    else {
      this.hasCharRepetition = 'false';
    }

    for (let i = 0; i < alphabets.length; i++) {
      if (i == 0) {
        let curAlphabet: any[] = alphabets[i][0];
        for (let j = 0; j < curAlphabet.length; j++) {
          if (j == 0) {
            this.alphabet1 = curAlphabet[j];
          }
          else {
            this.alphabet1 = this.alphabet1 + "," + curAlphabet[j];
          }
        }
        this.wordLength1 = alphabets[i][1];
      }
      if (i == 1) {
        let curAlphabet: any[] = alphabets[i][0];
        for (let j = 0; j < curAlphabet.length; j++) {
          if (j == 0) {
            this.alphabet2 = curAlphabet[j];
          }
          else {
            this.alphabet2 = this.alphabet2 + "," + curAlphabet[j];
          }
        }
        this.wordLength2 = alphabets[i][1];
      }
      if (i == 2) {
        let curAlphabet: any[] = alphabets[i][0];
        for (let j = 0; j < curAlphabet.length; j++) {
          if (j == 0) {
            this.alphabet3 = curAlphabet[j];
          }
          else {
            this.alphabet3 = this.alphabet3 + "," + curAlphabet[j];
          }
        }
        this.wordLength3 = alphabets[i][1];
      }
      if (i == 3) {
        let curAlphabet: any[] = alphabets[i][0];
        for (let j = 0; j < curAlphabet.length; j++) {
          if (j == 0) {
            this.alphabet4 = curAlphabet[j];
          }
          else {
            this.alphabet4 = this.alphabet4 + "," + curAlphabet[j];
          }
        }
        this.wordLength4 = alphabets[i][1];
      }
    }
    if (this.tree != null) {
      if (this.tree instanceof TreeWords) {
        this.tree.subGraphMode = false;
      }
    }
    this.generateTree();

    let hideCount: number = (Math.floor(Math.random() * this.tree.getNodes().length) + 1) / 2;

    if (this.tree instanceof TreeWords) {
      this.tree.hideRandomNodes(hideCount);
    }
    this.solutionButton.innerText = this.get("showSolution");
    this.showsSolution = true;


    this.tree.update();

  }

  showSolution = () => {
    if (this.tree == null)
      return;

    if (this.tree instanceof TreeWords) {
      if (this.showsSolution) {
        this.solutionButton.innerText = this.get("hideSolution");
        this.tree.showSolution();
      } else {
        this.solutionButton.innerText = this.get("showSolution");
        this.tree.hideSolution();
      }
    }
    this.showsSolution = !this.showsSolution;
  }

  hideContent = () => {
    if (this.tree == null) {
      return;
    }

    if (this.tree instanceof TreeWords) {
      this.tree.setHideNodeMode();
    }
  }

  generateTree = () => {
    let hasRepetition = (this.hasCharRepetition == 'true');
    let alpArgument: [any[], number][] = this.preprocessData(hasRepetition);
    this.tree = new TreeWords(alpArgument, hasRepetition, this.canvas);

    this.solutionButton.innerText = this.get("showSolution");
    this.showsSolution = true;

    if (this.tree instanceof MultiSetTreeBuilder)
      this.tree.buildTree();
    this.tree.update();

  }

  onSelectSubTree = () => {
    if (this.tree != null) {
      if (this.tree instanceof TreeWords) {
        this.tree.setSubTreeMode();
      }
    }
    this.solutionButton.innerText = this.get("showSolution");
    this.showsSolution = true;
  }

  backToGraph = () => {
    if (this.tree != null) {
      if (this.tree instanceof TreeWords) {
        this.tree.setGraphMode();
        this.tree.update();
      }
    }
  }



  private preprocessData(hasRepetition: boolean): [any[], number][] {
    let alphabets: string[][] = [];
    let alpLengths: number[] = [];
    let data: [any[], number][] = [];

    alphabets.push(this.alphabet1.split(","));
    alphabets.push(this.alphabet2.split(","));
    alphabets.push(this.alphabet3.split(","));
    alphabets.push(this.alphabet4.split(","));
    alphabets.push(this.alphabet5.split(","));
    alphabets.push(this.alphabet6.split(","));

    if (!hasRepetition) {
      this.wordLength1 = Math.min(Number(this.wordLength1), alphabets[0].length);
      this.wordLength2 = Math.min(Number(this.wordLength2), alphabets[1].length);
      this.wordLength3 = Math.min(Number(this.wordLength3), alphabets[2].length);
      this.wordLength4 = Math.min(Number(this.wordLength4), alphabets[3].length);
      this.wordLength5 = Math.min(Number(this.wordLength5), alphabets[4].length);
      this.wordLength6 = Math.min(Number(this.wordLength6), alphabets[5].length);
    }

    alpLengths.push(Number(this.wordLength1));
    alpLengths.push(Number(this.wordLength2));
    alpLengths.push(Number(this.wordLength3));
    alpLengths.push(Number(this.wordLength4));
    alpLengths.push(Number(this.wordLength5));
    alpLengths.push(Number(this.wordLength6));



    for (let i = 0; i < this.alphabetCount; i++) {
      data.push([alphabets[i], alpLengths[i]]);
    }
    return data;

  }

  getWordLength(): number[] {
    let i = 0;
    let res = [];
    for (i = 1; i <= this.maxWordLength; i++) {
      res.push(i);
    }
    return res;
  }


  generateDefinition(): any {

    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/allWords.png';
    definition.key = 'listingWithTreeDiagrams%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    if (this.tree == null) {
      alert("Generieren Sie vorerst den Baum")
    }
    else {
      if (this.tree instanceof MultiSetTreeBuilder)
        this.treeService.exportTree(this.tree, definition, false);
    }
    if (this.tree instanceof TreeWords) {
      this.tree.hideSolution();
      this.treeService.exportSubTreeNode(this.tree.getSubNode(), definition);
      this.treeService.exportMultiHiddenContent(this.tree.getHiddenNodes(), definition);
    }

    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    /*Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized*/
    let alphabet: [any[], number][] = this.treeService.importMultiTree(this.configuration);
    let hasRepetition: boolean = this.treeService.importHasRepetition(this.configuration);

    this.tree = new TreeWords(alphabet, hasRepetition, this.canvas);
    this.hasCharRepetition = "" + hasRepetition;

    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.hideContentButton = <HTMLButtonElement>document.getElementById(this.hideContentID);
    this.subTreeButton = <HTMLButtonElement>document.getElementById(this.subTreeID);
    this.backButton = <HTMLButtonElement>document.getElementById(this.backID);
    this.solutionButton = <HTMLButtonElement>document.getElementById(this.solutionID);
    this.solutionButton.innerText = this.get("showSolution");

    //If we load from configfile we dont need to create a new empty graph
    if (!this.readFromConfig) {
      this.generateTreeButton.addEventListener('click', this.generateTree, false);
      this.hideContentButton.addEventListener('click', this.hideContent, false);
      this.subTreeButton.addEventListener('click', this.onSelectSubTree, false);
      this.backButton.addEventListener('click', this.backToGraph, false);
      this.solutionButton.addEventListener('click', this.showSolution, false);

    }


    this.alphabetCount = alphabet.length;
    for (let i = 0; i < this.alphabetCount; i++) {
      let str: string = "";
      if (i == 0) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet1 = str.substr(1);
        this.wordLength1 = alphabet[i][1];
      }
      else if (i == 1) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet2 = str.substr(1);
        this.wordLength2 = alphabet[i][1];
      }
      else if (i == 2) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet3 = str.substr(1);
        this.wordLength3 = alphabet[i][1];
      }
      else if (i == 3) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet4 = str.substr(1);
        this.wordLength4 = alphabet[i][1];
      }
      else if (i == 4) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet5 = str.substr(1);
        this.wordLength5 = alphabet[i][1];
      }
      else if (i == 5) {
        alphabet[i][0].forEach(elem => {
          str = str + "," + elem;
        })
        this.alphabet6 = str.substr(1);
        this.wordLength6 = alphabet[i][1];

      }

    }
    let hiddenContent: any[][] = this.treeService.importHiddenNodes(this.configuration);
    let subNodeContent: any[] = this.treeService.importSubNode(this.configuration);
    if(this.tree instanceof MultiSetTreeBuilder)
       this.tree.buildTree();

    if (this.tree instanceof TreeWords) {
      this.tree.setHiddenNodes(hiddenContent);
      this.tree.setSubNode(subNodeContent);
    }

    this.tree.update();
    this.readFromConfig = true;
  }

  private initHiddenNodes() {

  }

  private sameContent(realContent: any[], content: any[]): boolean {
    let hasSameContent: boolean = true;
    hasSameContent = content.length == realContent.length;

    let i: number = 0;
    for (i = 0; i < content.length; i++) {
      hasSameContent = hasSameContent && (content[i] == realContent[i]);
    }
    return hasSameContent;
  }


}


